import { Box, Button, Typography } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import React from 'react';
import { type HealthScore } from 'types/squares.type';
import useCustomerInfo from 'hooks/useCustomerInfo';
import { useTranslation } from 'react-i18next'; // Ensure this path is correct
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface HeaderProps {
  allAssets: HealthScore[];
  handleIsWorkOrder: (check: boolean) => void;
  isUploadWorkOrder: boolean;
  onMonthSelect: (selectedMonth: string | null) => void;
}

const Header: React.FC<HeaderProps> = ({
  allAssets,
  handleIsWorkOrder,
  isUploadWorkOrder,
  onMonthSelect,
}) => {
  const { t } = useTranslation();
  const { customerCode } = useCustomerInfo();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px',
        }}
      >
        <Typography
          style={{
            color: palette.textPrimary,
          }}
          variant="h6"
          component="div"
          sx={{ flexGrow: 1 }}
        >
          {t('current_health_status')}
        </Typography>
        {customerCode !== 'drn' && (
          <Button
            size="small"
            variant="outlined"
            style={{
              padding: '10px',
              fontSize: '0.7rem',
              color: palette.white,
              background: palette.primary,
              border: `1px solid ${palette.primary}`,
              textTransform: 'uppercase',
            }}
            sx={{
              '&:hover': {
                backgroundColor: palette.primaryDark,
                borderColor: palette.primaryDark,
              },
            }}
            onClick={() => {
              handleIsWorkOrder(!isUploadWorkOrder);
            }}
          >
            {isUploadWorkOrder ? 'Return to Dashboard' : 'Upload Work Order'}
          </Button>
        )}
      </Box>

      {/* Show the timeline only if not in upload work order mode */}
      {/* {!isUploadWorkOrder && (
        <SquareServiceTimeline
          services={allAssets}
          enableDarkTheme={enableDarkTheme}
          onMonthSelect={handleMonthSelect} // Pass the handleMonthSelect function to the timeline
        />
      )} */}
    </Box>
  );
};

export default Header;
